import fileDownload from 'js-file-download';
import { ClearLocStorageItem } from '../../utils';
import { RefreshToken } from './RefreshToken';
import { RequestHandler } from './RequestHandler';



export const APICall = async (method, API, params) => {
    await RefreshToken()

    return await RequestHandler(method, API, params)
}

export const GetRequest = async (apiLink) => {
    return await APICall("get", apiLink)
}

export const GetExcelRequest = async (link ,controllerName = "data-file") => { // controllerName also used as name for the file
    return GetRequest(link)
        .then(file => {

            return new Promise((resolve) => {
                fileDownload(file, `${controllerName}.xlsx`)
                resolve()
            })
        })
}

export const PostRequest = async (apiLink, data) => {
    return await APICall("post", apiLink, data)
}
export const PatchRequest = async (apiLink, data) => {
    return await APICall("patch", apiLink, data)
}
export const PutRequest = async (apiLink, data) => {
    return await APICall("put",apiLink, data)
}
export const DeleteRequest = async (apiLink) => {
    return await APICall("delete", apiLink)
}




export const forceLogout = () => {
    ClearLocStorageItem("ut")
    ClearLocStorageItem("rt")
    window.location.reload()
}
